var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V15H5C4.44772 15 4 15.4477 4 16C4 16.5523 4.44772 17 5 17H15V27C15 27.5523 15.4477 28 16 28C16.5523 28 17 27.5523 17 27V17H27C27.5523 17 28 16.5523 28 16C28 15.4477 27.5523 15 27 15H17V5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusBlack);
export default __webpack_public_path__ + "static/media/ic_plus_black.fe86fc13.svg";
export { ForwardRef as ReactComponent };